import React from 'react';
import predictionIcon from '../../../assets/icons/alert-png.png';
import rawsIcon from '../../../assets/icons/raws-icon-colored.png';
import fireContainedUrl from '../../../assets/icons/fire-gray.png';
import fireHalfContainedUrl from '../../../assets/icons/fire-half-gray.png';
import fireCircleUrl from '../../../assets/icons/fire-red-orange.png';
import fireAlmostGray from '../../../assets/icons/fire-almost-gray.png';
import powerlinesIcon from '../../../assets/icons/powerlines-legend-icon.png'
import neabyInfraIcon from '../../../assets/icons/nearby-infrastructure-icon.png';
import hotspotsIcon from '../../../assets/icons/hotspots-legend-icon.png';
import planeIcon from '../../../assets/icons/plane-icon-2.png';
import satelliteIcon from '../../../assets/icons/satellite-icon-2.png';
import perimeterIcon from '../../../assets/icons/perimeter-legend-icon.png';
import oneMileRadiusIcon from '../../../assets/icons/one-mi-radius-legend-icon.png';
import fiveMileRadiusIcon from '../../../assets/icons/five-mi-radius-legend-icon.png';
import shelterIcon from '../../../assets/icons/shelter-icon-2.png'

export default function Legend() {
    const items = [
        {
            name: 'Wildfire Prediction',
            icon: predictionIcon,
            description: 'Real-time wildifre prediction powered by advanced AI and machine learning algorithms.'
        },
        {
            name: 'Reported Fire',
            icon: fireCircleUrl,
            description: 'Reported fire with less than 40% containment.'
        },
        {
            name: 'Reported Fire',
            icon: fireHalfContainedUrl,
            description: 'Reported fire greater than 40% containment.'
        },
        {
            name: 'Reported Fire',
            icon: fireAlmostGray,
            description: 'Reported fire greater than 90% containment.'
        },
        {
            name: 'Reported Fire',
            icon: fireContainedUrl,
            description: 'Reported fire with 100% containment.'
        },
        {
            name: 'RAWS',
            icon: rawsIcon,
            description: 'Remote Automated Weather Station (RAWS) weather data providing real-time environmental information.'
        },
        {
            name: 'VIIRS',
            icon: hotspotsIcon,
            description: 'Visible Infrared Imaging Radiometer Suite (VIIRS) detects and monitors wildfires by capturing thermal and visible imagery from space.'
        },
        {
            name: 'MODIS',
            icon: hotspotsIcon,
            description: 'Moderate Resolution Imaging Spectroradiometer (MODIS) detects and monitors wildfires by capturing thermal anomalies and fire activity from space.'
        },
        {
            name: 'Fire Perimeter',
            icon: perimeterIcon,
            description: 'Plotted polygon of reported fire perimeter.'
        },
        {
            name: '1 Mile Radius',
            icon: oneMileRadiusIcon,
            description: 'Plotted radius of 1 mile from reported fire.'
        },
        {
            name: '5 Mile Radius',
            icon: fiveMileRadiusIcon,
            description: 'Plotted radius of 5 miles from reported fire.'
        },
        {
            name: 'Powerlines',
            icon: powerlinesIcon,
            description: 'Representation of powerlines (Only for Fire Spread Simulation)'
        },
        {
            name: 'Nearby Infrastructure',
            icon: neabyInfraIcon,
            description: 'Nearby infrastructure potentially at risk (Only for Fire Spread Simulation)'
        },
        {
            name: 'Firefighting Aircraft',
            icon: planeIcon,
            description: 'Aircraft specializing in fire containment, along with its path.'
        },
        {
            name: 'Satellites',
            icon: satelliteIcon,
            description: 'Satellite specializing in disaster monitoring, weather/climate, Earth resources, and more, along with its path.'
        },
        {
            name: 'Nearby Shelters',
            icon: shelterIcon,
            description: 'Any nearby shelters that can be utilized for safety from the selected fire.'
        }
        // {
        //     name: 'Fire/EMS Stations',
        //     icon: emsIcon,
        //     description: 'Locations of fire and EMS stations, highlighting critical emergency response infrastructure for public safety and disaster management.'
        // },
        // {
        //     name: 'Power Plants',
        //     icon: powerPlantIcon,
        //     description: 'Locations of power plants, highlighting critical energy infrastructure for monitoring and wildfire prevention.'
        // }
    ]
    return (
        <div className='map-controls-settings-window-legend'>
                <div className='map-controls-settings-window-legend-title'>Map Legend</div>
                <div className='map-controls-settings-window-legend-description'>A detailed overview of what each icon on the map represents.</div>
                <div className='map-controls-settings-window-legend-container'>
                    <div className='map-controls-settings-window-legend-container-card'>
                        {items.map((item) => {
                            return (
                                <div className='map-controls-settings-window-legend-container-card-row'>
                                    <div className='map-controls-settings-window-legend-container-card-row-left'>
                                        {/* <img className='map-controls-settings-window-legend-container-card-row-left-img' src={item.icon} style={item.name === 'VIIRS' || item.name === 'MODIS' ? {border: '1px solid white', borderRadius: '50%'} : {}}/> */}
                                        <img className='map-controls-settings-window-legend-container-card-row-left-img' src={item.icon}/>
                                        <div className='map-controls-settings-window-legend-container-card-row-left-name'>{item.name}</div>
                                    </div>
                                    <div className='map-controls-settings-window-legend-container-card-row-right'>
                                        <div className='map-controls-settings-window-legend-container-card-row-right-line'></div>
                                        <div className='map-controls-settings-window-legend-container-card-row-right-description'>{item.description}</div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
        </div>
    )
}
